module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/FreeIssue-AstralitoAdultos.8e8286b0.png";